import axios from "axios";
import { aspNetUrl, newApiBaseUrl } from "../../axiosInstance";

export const getCoupons = () => {
  return axios
    .get(`${aspNetUrl}coupons`)
    .then((res) => res.data)
    .catch((e) => console.log(e));
};

export const createCoupon = (data) => {
  return axios.post(`${aspNetUrl}Coupon/AddCoupon`, data, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

export const useCoupon = (couponCode, customerId, orderId) => {
  return axios
    .post(
      `${aspNetUrl}Coupon/RedeemCoupon?couponCode=${couponCode}&customerId=${customerId}&orderId=${orderId}`,
      {
        headers: {
          Authorization: `bearer ${localStorage.token}`,
          "Access-Control-Allow-Origin": "*",
        },
      },
    )
    .then((res) => res.data)
    .catch((e) => console.log(e));
};

export const validateCoupon = async (couponCode, customerId, orderSum) => {
  try {
    const res = await axios.post(
      `${newApiBaseUrl}/coupons/validate`,
      {
        Amount: Number(orderSum).toFixed(2),
        Coupons: [couponCode],
        CustomerId: customerId,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${localStorage.jwtToken}`,
          "X-Tenant": "hamazon",
          "Access-Control-Allow-Origin": "*",
        },
      },
    );
    const originalAmount = Number(res.data.OriginalAmount);
    const finalAmount = Number(res.data.FinalAmount);
    const usedCoupons = res.data.UsedCoupons || [];

    return {
      Success: usedCoupons.includes(couponCode),
      Coupon: {
        CouponCode: couponCode,
        Sum: originalAmount - finalAmount,
        MinOrder: 0,
      },
      Message: usedCoupons.includes(couponCode)
        ? undefined
        : "קוד הקופון אינו תקין",
    };
  } catch (e) {
    return console.log(e);
  }
};
